import {makeStyles, Theme} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    boxSizing: 'border-box',
  },
  ctaContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
  },
  buttonsContainer: {
    height: 40,
    width: '100%',
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    gap: 5,

  },
  tableContainer: {
    height: "calc(100% - 40px)",
    width: "100%",
  },
  iconContainer: {
    display: "inline-block",
    cursor: "pointer",
  },
  loadedText: {
    width: 200,
    fontSize: 12,
    flexGrow: 1,
    color: theme.palette.grey[500],
    margin: 0,
  },
}));